import { Grid, Box, Typography, Switch } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FormInput } from 'gf-ui-components-mui-lib';
import { FilterSvg } from '@/icons';
import SearchSvg from '@/images/svg/search.svg';
import { CommonButtons } from '@/apps/user-and-group/user/createUser/commonButtons';
import { ExportIcon, Mask, Tv } from '@/icons';
import { ExportBtn } from '@/apps/core/elements/Buttons';
import TickAndCrossbtn from '../elements/Buttons/TickAndCrossbtn';
import SelectWrapper from '../elements/Inputs/SelectWrapper';

const SearchAndExportSection = ({
  managementStatus,
  userSelected,
  isSmallScreen,
  create,
  handleSave,
  name,
  value,
  handleChange,
  handleuserPopup,
  handleExportButtonClick,
  disabled,
  handleToGroup,
  portal,
  tab,
  setTab,
  handleCloseDrawer,
  disableItems,
  setDeveloperPage,
  hideExportButton = false,
  toggleAccess,
  access = {
    export: false,
  },
  portalSwitch = false,
  handlePortalSwitch = {},
  setPortalSwitch = {},
  showApplication = false,
  applicationsOptions,
  applicationId = '',
  handleApplicationSelect,
}: any) => {
  const navigate = useNavigate();
  const width = isSmallScreen ? '45px' : '52px';
  const showExportButton = access['export'];

  const formInputStyles = {
    input: {
      '&::placeholder': {
        textOverflow: 'ellipsis !important',
        color: '#CACEDC',
      },
    },
    '& .MuiOutlinedInput-root': {
      height: width,
      borderRadius: '9px',
      backgroundColor: '#FFFFFF',
      padding: '10px 14px',
      gap: '5.94px',
      border: '1px solid #E2E8F0',
      boxShadow: '1.999999761581421px 3.999999523162842px 9.999999046325684px 0px rgba(180, 191, 205, 0.12)',
    },
    '& .MuiOutlinedInput-root.Mui-focused fieldset': {
      border: 'none',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-input': {
      height: '22px',
      backgroundColor: 'inherit',
      fontFamily: 'Inter',
      fontWeight: 500,
      fontSize: '18px',
      lineHeight: '22px',
      padding: 0,
      color: '#000000',
    },
  };

  return (
    <Grid
      container
      direction={'row'}
      justifyContent={'space-between'}
      sx={{ opacity: disableItems ? 0.3 : 1 }}
      className="search-export-section"
    >
      <Grid item display={'flex'} alignItems={'center'}>
        <Grid
          item
          width={'382px'}
          sx={{
            opacity: create ? 0.3 : 1,
          }}
          className="search-bar"
        >
          <FormInput
            sx={formInputStyles}
            onChange={handleChange}
            value={value}
            startIcon={<img src={SearchSvg} alt="logo" height={24} width={24} />}
            placeholder="Search"
            name={name}
            disabled={disabled}
          />
        </Grid>
        {!create && (
          <Grid item pl={'12px'}>
            <Box
              sx={{
                display: 'flex',
                width: width,
                height: width,
                padding: '12px',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '4px',
                borderRadius: '9px',
                background: '#FFF',
                boxShadow: '2px 4px 10px 0px rgba(180, 191, 205, 0.20)',
                cursor: 'pointer',
              }}
              className="filter-btn"
            >
              <FilterSvg />
            </Box>
          </Grid>
        )}
        {showApplication && (
          <Grid container pl={1} gap={'6px'}>
            <SelectWrapper
              {...{
                options: applicationsOptions,
                name: applicationId,
                styles: {
                  height: '50px',
                  margin: 0,
                },
                onChange: handleApplicationSelect,
              }}
            />
          </Grid>
        )}
        {userSelected?.length > 0 && managementStatus === 'Users' && (
          <Grid item>
            <CommonButtons
              isSmallScreen={isSmallScreen}
              handleuserPopup={handleuserPopup}
              userSelected={userSelected}
            />
          </Grid>
        )}
        {toggleAccess && portal && (
          <Grid
            item
            ml={2}
            sx={{
              display: 'flex',
              padding: '8px 16px',
              alignItems: 'center',
              gap: '16px',
              alignSelf: 'stretch',
              borderRadius: '8px',
              background: '#FFF',
            }}
            className="main-portal-tabs"
          >
            <Grid
              item
              sx={{
                display: 'flex',
                padding: '0px 16px',
                alignItems: 'center',
                gap: '8px',
                alignSelf: 'stretch',
                borderRadius: tab === 'Publisher' ? '24px' : '0px',
                background: tab === 'Publisher' ? '#6191F2' : 'none',
                cursor: 'pointer',
              }}
              onClick={() => {
                setPortalSwitch(false);
                setTab('Publisher');
                handleCloseDrawer('Developer', false);
              }}
              className={`${tab !== 'Publisher' ? 'not-select' : ''}`}
            >
              <Box
                sx={{
                  display: 'flex',
                  width: '16px',
                  height: '16px',
                  padding: '2px',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Mask fill={tab === 'Publisher' ? 'white' : 'black'} />
              </Box>
              <Typography
                sx={{
                  color: tab === 'Publisher' ? '#FFF' : '#242424',
                  fontFamily: 'Inter',
                  fontSize: '18px',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: '22px',
                }}
              >
                Publisher Portal
              </Typography>
            </Grid>
            <Switch
              // checked={tab === 'Developer' ? true : false}
              checked={portalSwitch}
              onChange={handlePortalSwitch}
              sx={{
                '& .MuiSwitch-thumb': {
                  background: '#2469F3',
                },
                '& .MuiSwitch-track': {
                  background: '#6191F2 !important',
                },
                '& .Mui-checked+.MuiSwitch-track': {
                  backgroundColor: '#6191F2',
                },
                '& .MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
                  backgroundColor: '#6191F2',
                },
              }}
            />
            <Grid
              item
              sx={{
                display: 'flex',
                padding: '0px 16px',
                alignItems: 'center',
                gap: '8px',
                alignSelf: 'stretch',
                borderRadius: tab === 'Developer' ? '24px' : '0px',
                background: tab === 'Developer' ? '#6191F2' : 'none',
                cursor: 'pointer',
              }}
              onClick={() => {
                setPortalSwitch(true);
                setTab('Developer');
                handleCloseDrawer('Publisher', false);
                setDeveloperPage('API');
              }}
              className={`${tab !== 'Developer' ? 'not-select' : ''}`}
            >
              <Box
                sx={{
                  display: 'flex',
                  width: '16px',
                  height: '16px',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Tv fill={tab === 'Developer' ? 'white' : 'black'} />
              </Box>
              <Typography
                sx={{
                  color: tab === 'Developer' ? '#FFF' : '#242424',
                  fontFamily: 'Inter',
                  fontSize: '18px',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: '22px',
                }}
              >
                Developer Portal
              </Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
      {!hideExportButton ? (
        create ? (
          <Grid item>
            <Grid
              item
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: isSmallScreen ? '15px' : '24px',
              }}
            >
              <TickAndCrossbtn
                {...{
                  disabled: false,
                  onClickCross:
                    managementStatus === 'Groups' ? handleToGroup : () => navigate('/dashboard/users-and-groups'),
                  onClickTick: handleSave,
                }}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid
            item
            sx={{
              ...(!showExportButton && { pointerEvents: 'none', opacity: 0.3 }),
            }}
          >
            <ExportBtn
              onClick={handleExportButtonClick}
              children="Export"
              isSmallScreen={isSmallScreen}
              startIcon={<ExportIcon />}
            />
          </Grid>
        )
      ) : null}
    </Grid>
  );
};

export default SearchAndExportSection;
